import { render, staticRenderFns } from "./Successpayment.vue?vue&type=template&id=768075d8&scoped=true&"
import script from "./Successpayment.vue?vue&type=script&lang=js&"
export * from "./Successpayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768075d8",
  null
  
)

export default component.exports